import React, {useEffect, useState} from "react";
import {Alert, Radio, Table, Tag} from "antd";
import {ApiLinksService} from "../../../../../shared/api";
import {errorOf, formatDuration} from "./linkParts";

const FILTERS = [
  {value: 'all', label: 'Все'},
  {value: 'login', label: 'Вошли'},
  {value: 'registered', label: 'Зарегистрировались'},
]

const formatPhone = (phone) => {
  const d = String(phone || '').replace(/\D/g, '')
  return d.length === 11 ? `+7 (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7, 9)}-${d.slice(9)}` : phone
}

// Who came by the link: agents the site recognised (signed in or registered in a visit from the link), with their
// visits and time on the site. Personal data: shown, not stored.
export const LinkPeople = ({linkId, filter, onFilter}) => {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    let alive = true
    ApiLinksService.fetchPeople(linkId)
      .then(({data: d}) => alive && setData(d))
      .catch((e) => alive && setError(errorOf(e).message || 'Не удалось получить список'))
    return () => {
      alive = false
    }
  }, [linkId])

  if (error) return <Alert type='error' showIcon message={error}/>
  if (data && !data.supported) return <Alert type='info' showIcon message='Узнавать людей умеем только на eci-spb.ru.'/>

  const people = (data ? data.people : []).filter((p) => filter === 'all' || p[filter])

  return (
    <div className='link-people'>
      <Radio.Group optionType='button' size='small' options={FILTERS} value={filter} onChange={(e) => onFilter(e.target.value)}/>
      <Table
        size='small'
        rowKey={(p) => p.id || `${p.phone}-${p.lastDay}`}
        loading={!data}
        dataSource={people}
        pagination={{pageSize: 20, hideOnSinglePage: true}}
        locale={{emptyText: 'Пока никого: люди видны, если вошли или зарегистрировались в визите по этой ссылке'}}
        scroll={{x: 760}}
        columns={[
          {
            title: 'Кто',
            key: 'name',
            render: (p) => (
              <>
                <b>{p.name || (p.id ? `Пользователь № ${p.id}` : 'Не найден на сайте')}</b>
                {(p.agency || p.position) && <div className='cell-hint'>{[p.agency, p.position].filter(Boolean).join(' · ')}</div>}
              </>
            ),
          },
          {
            title: 'Контакты',
            key: 'contacts',
            render: (p) => (
              <>
                {p.phone && <div style={{whiteSpace: 'nowrap'}}>{formatPhone(p.phone)}</div>}
                {p.email && <div className='cell-hint'>{p.email}</div>}
              </>
            ),
          },
          {
            title: 'Что сделал',
            key: 'did',
            render: (p) => (
              <div className='tag-list'>
                {p.login && <Tag color='blue'>вошёл</Tag>}
                {p.registered && <Tag color='green'>зарегистрировался</Tag>}
              </div>
            ),
          },
          {title: 'Визитов', dataIndex: 'visits', align: 'right', width: 80},
          {title: 'Время на сайте', key: 'time', align: 'right', width: 120, render: (p) => formatDuration(p.time)},
          {title: 'Последний визит', key: 'lastDay', width: 130, render: (p) => (p.lastDay ? new Date(p.lastDay).toLocaleDateString('ru-RU') : '—')},
        ]}
      />
    </div>
  )
}
